import React from 'react'
import backimg from '../img/image2.png'
import './style/AboutPost.css'

function AboutPost() {
    return (
        <div id='aboutpost'>
            <div className='wrap-post'>
                <div className='post-title'>
                    <span>about GuHyun</span>
                </div>
            </div>
        </div>
    )
}

export default AboutPost